import React from 'react';

import PageTitleNew from 'components/ui/PageTitleNew';

import DataTable from 'react-data-table-component';

import { Button } from 'react-bootstrap';

import useAvatars from 'components/Admin/Avatars/Hooks/useAvatars';
import { useNavigate } from 'react-router-dom';
import columns from './columns';

export default function Index() {
  const { avatars, refresh } = useAvatars();

  const navigate = useNavigate();

  const onCreateClick = () => {
    navigate('/admin/avatars/new');
  };

  return (
    <div className="wrapper_assestment invite_wrapper">
      <PageTitleNew title="AI Coaches" />

      <div className="text-right">
        <Button
          onClick={onCreateClick}
          bsStyle="primary"
        >
          Add AI Coach
        </Button>
      </div>

      <div className="ibox-content mt20">
        <div className="datatable-style">

          <DataTable
            title=""
            columns={columns(refresh)}
            data={avatars || []}
            noDataComponent={(
              <div className="mt20">
                {avatars == null
                  ? 'Please, wait ...'
                  : 'No matching records found'}
              </div>
          )}
            persistTableHead
            pagination
            paginationComponentOptions={{
              selectAllRowsItem: true,
              selectAllRowsItemText: 'All',
            }}
          />
        </div>
      </div>
    </div>
  );
}
